import React from 'react';
import css from './loading-overlay.css';

import CircularProgress from 'material-ui/CircularProgress';
import Overlay from 'material-ui/internal/Overlay';

function ProgressIndicator(props) {
  if (props.loading) {
    return (
      <div className={css.saving}>
        <CircularProgress size={props.size * 59.5 || 120} />
      </div>
    );
  }
}

function LoadingOverlay(props) {
  return (
    <div>
      <Overlay
        show={props.loading}
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', zIndex: 2 }}
      />
      {ProgressIndicator(props)}
    </div>
  );
};

export default LoadingOverlay;



/** WEBPACK FOOTER **
 ** ./components/LoadingOverlay.js
 **/